module.exports = __webpack_public_path__ + "static/media/reportBadgeLevel2Locked.7f6baa0c.png";